













































































import Vue from "vue";
import snack from "@/components/snackbar.vue";
import globalDialog from "@/components/dialog.vue";
export default Vue.extend({
  name: "App",
  components: { snack, globalDialog },
  data: () => {
    return {
      menu: false
    };
  },
  computed: {
    packageVersion() {
      return process.env.VUE_APP_VERSION;
    },
    isLoggedIn() {
      return (
        this.$store.getters["userInfo"].userSignedIn &&
        this.$route.name !== "Login"
      );
    }
  },
  methods: {
    async logout() {
      this.menu = false;
      this.$router.push({ name: "Login" });
    }
  }
});
